import { envConfig } from '@root/env';
import { Post } from '@/service/request/server';

const baseUrl = envConfig.formalServer + '/cotton/admin/product/';

function baseApi() {

    function insert(data) {

    }

    function batchInsert(list) {
        return Post(baseUrl + `batchInsertProduct`, list);
    }

    function deleteData(productId) {
        return Post(baseUrl + `deleteProduct/${productId}`, null);
    }

    function update(data) {

    }

    function query(data, projectName) {

    }

    return {
        insert, batchInsert, deleteData, update, query
    };
}

export const productApi = baseApi();
